<button ngbDropdownItem type="button" (click)="export()">
  <cx-icon type="DOWNLOAD_BLUE"></cx-icon>
  {{ 'importExport.cart.export' | cxTranslate }}
</button>
